<template>
	<div class="donation-source card-component px30 pt-8 flex flex-col">
		<button type="button" class="btn-empty-wrapper mr-5 mb-5" @click="clickHandler">
			<Close icon="back" />
		</button>
		<h3 class="page-title color-text font-bold text-28 text-text tracking-tight leading-tight mb-5">
			<span class="text-primary">{{ $t('RoundUp') }}</span>
			<span class="text-secondary">{{ $t('Accounts') }}</span>
		</h3>
		<ul class="card-list">
			<li v-for="(card, index) in cards" :key="index">
				<BankItem :card="card" @actionWithCard="actionWithCard" :clickHandler="back" />
			</li>
		</ul>
		<button v-ripple type="button"
			class="card-add-card flex flex-col justify-center items-center text-text leading-5 mb-7"
			@click="addAccount">
			<span class="text-36 block mb-2">+</span><span class="text-14 block font-bold">{{ $t('Add another account')
			}}</span>
		</button>
		<LoaderModal />
	</div>
</template>

<script>
import Close from '../UI/Close';
import CardItem from './CardItem';
import AddCard from '../Card/AddCard';
import AuthorizeInfo from '../Card/AuthorizeInfo';
import BankItem from './BankItem';
import LoaderModal from '../Modal/LoaderModal.vue'
import mixins from '../../config/mixins';

export default {
	name: 'BankAccount',
	components: { BankItem, AuthorizeInfo, AddCard, CardItem, Close, LoaderModal },
	mixins: [mixins.plaid],
	props: ['clickHandler'],

	data: function () {
		return {
			cards: [],
			processHandler: '',
			card: {},
			cardIndex: '',
			plaidData: null,
		};
	},

	mounted() {
		this.getListBanks();
	},

	methods: {
		addAccount: function () {
			this.recreate = 0;
			this.plaidLoad();
		},

		reCreateAccount: function (index) {
			this.recreate = index;
			this.plaidLoad();
		},

		async deletePlaidAccount (index) {
			const payload = {
				id: index 
			}
			const {status} = await this.$http.post('user/deletePlaidAccount', payload)
			if(!status) return
			this.back();
			await this.getListBanks();
			const keys = Object.keys(this.cards)
			if(keys && keys.length) return
			location.reload()	
		},

		async savePosCard (index) {
			const payload = {
				pos_id: index 
			}
			const { status } = await this.$http.post('user/poscard', payload)
			if(!status) return
			this.back();
			this.getListBanks();
		},
		actionWithCard (obj) {
			switch (obj.action) {
				case 'savePos':
					this.savePosCard(obj.index);
					break;
				case 'deletePlaidAccount':
					this.deletePlaidAccount(obj.index);
					break;
				case 'reCreateAccount':
					this.reCreateAccount(obj.index);
					break;
				default:
					return false;
			}
		},
		back (value) {
			this.processHandler = '';
			this.card = [];
			this.cardIndex = '';
			if (value === 'authorize' || value === 'addAnotherCard') {
				this.getListBanks();
			}
		},
		async getListBanks () {
			this.cards = {};
			const {status, data} = await this.$http.get('user/listbank')
			if(status) {
				this.cards = data['bank_data'] || {}
			}
		},
	},
};
</script>
